var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "rbv-dropdown",
    {
      class: _vm.$style.dropdown,
      attrs: { "is-open": _vm.opened, "backdrop-style": "transparent" },
      on: {
        close: function ($event) {
          _vm.opened = false
        },
      },
    },
    [
      _c(
        "div",
        { attrs: { slot: "toggler" }, slot: "toggler" },
        [
          _c(
            "rb-input",
            {
              class: _vm.$style.searchBar,
              attrs: { "for-id": "search_address" },
            },
            [
              _c("label", { attrs: { slot: "label" }, slot: "label" }, [
                _vm._v(" Address Search "),
              ]),
              _c("div", { class: _vm.$style.searchBar }, [
                _c("input", {
                  staticClass: "rbInput",
                  class: _vm.$style.searchBarInput,
                  attrs: {
                    id: "search_address",
                    autocomplete: "off",
                    placeholder: "Search for Address",
                  },
                  domProps: { value: _vm.viewValue },
                  on: {
                    focus: function ($event) {
                      _vm.opened = true
                    },
                    blur: function ($event) {
                      _vm.opened = false
                    },
                    input: _vm.onQueryChange,
                  },
                }),
                _c(
                  "div",
                  { class: _vm.$style.searchBarIconContainer },
                  [
                    _vm.loading
                      ? _c("rb-loading", {
                          staticClass: "small",
                          class: _vm.$style.searchBarLoading,
                        })
                      : _c(
                          "i",
                          {
                            staticClass: "material-icons",
                            class: _vm.$style.searchBarIcon,
                          },
                          [_vm._v("search")]
                        ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.opened && _vm.viewValue && _vm.viewValue.length,
              expression: "opened && viewValue && viewValue.length",
            },
          ],
          staticClass: "dropdownContainer dropdown-content",
          class: _vm.$style.dropdownContainer,
          attrs: { slot: "dropdown" },
          slot: "dropdown",
        },
        [
          _c(
            "div",
            { class: _vm.$style.scrollContainer },
            _vm._l(_vm.predictions, function (prediction) {
              return _c(
                "div",
                {
                  key: prediction.id,
                  class: _vm.$style.address,
                  on: {
                    mousedown: function ($event) {
                      return _vm.onSelected(prediction)
                    },
                  },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.addressIcon,
                    },
                    [_vm._v("location_on")]
                  ),
                  _vm._v(" " + _vm._s(prediction.description) + " "),
                ]
              )
            }),
            0
          ),
          _vm.showForm === 0
            ? _c("div", { class: _vm.$style.addManuallyBox }, [
                _c("div", { class: _vm.$style.addManuallyText }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.addManuallyIcon,
                    },
                    [_vm._v("info")]
                  ),
                  _vm._v(
                    " If you are unable to find the address you can always add it manually "
                  ),
                ]),
                _c(
                  "button",
                  {
                    staticClass: "rb-button primary",
                    on: { mousedown: _vm.onAddManually },
                  },
                  [
                    _c("i", { staticClass: "material-icons" }, [
                      _vm._v("add_box"),
                    ]),
                    _vm._v("Add Manually "),
                  ]
                ),
              ])
            : !(_vm.predictions && _vm.predictions.length)
            ? _c("div", { class: _vm.$style.noResultsBox }, [
                _c("div", { class: _vm.$style.noResultsText }, [
                  _c(
                    "i",
                    {
                      staticClass: "material-icons",
                      class: _vm.$style.noResultsIcon,
                    },
                    [_vm._v("info")]
                  ),
                  _vm._v(" No results! "),
                ]),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }